import { ILocale } from "./locale.interface"

export class Locale {
  locale: string
  baseLocale: string
  translations: any
  constructor (from: ILocale) {
    this.locale = from.locale
    this.baseLocale = from.baseLocale
    this.translations = from.translations
  }
}